import React from "react";
import { connect } from "react-redux";
import { Popup, ScrollView } from "devextreme-react";
import SaledOrderForm from "../Form";

function SaleOrderDataEntryPopup(props) {
    return (<>
        {props.showPopup.visible==true ? (
        <Popup
            deferRendering={false}
            animation={null}
            visible={props.showPopup.visible}
            onHiding={() => props.setShowPopup(prevFormData=>({...prevFormData,visible:false}))}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={props.title}
            width="90vw"
            height="90vh"
        >
            <ScrollView height="100%" width="100%">
              <SaledOrderForm id={props.showPopup.id} />
            </ScrollView>
        </Popup>):(null)}
    </>);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SaleOrderDataEntryPopup);
